import Filters from './Filters'
class NumberOfGuest extends Filters {
	constructor (container, itemsContainer) {
		super(itemsContainer)
		this.container = container
		this.state = {
			value: '',
			default: true
		}
		this.init()
	}

	init () {
		this.fields = this.container.querySelector('#numberOfGuest')
		this.fieldNumber = this.fields.querySelector('#guestNumber')
		this.fieldType = [...this.fields.querySelectorAll('#guestType input')]
		this.addListeners()
	}

	addListeners () {
		this.fieldNumber.addEventListener('change', () => {
			this.state.value = this.fieldNumber.value
			this.update()
		})

		this.fieldType.forEach(radio => {
			radio.addEventListener('change', () => {
				this.state.default = this.fieldType[0].checked
				this.resetActiv()
				this.update()
			})
		})
	}

	resetActiv () {
		this.fieldType.forEach(radio => {
			if (radio.checked) {
				radio.parentElement.classList.add('active')
			} else {
				radio.parentElement.classList.remove('active')
			}
		})
	}

	update () {
		this.set(this.state)
	}

	blockFilters () {
		// this.input.disabled = true
	}

	unblockFilters () {
		// this.input.disabled = false
    }

    resetFilter () {
        this.state.value = ''
        this.fieldNumber.value = ''
        this.state.default = true
        this.fieldType[0].checked = true
        this.fieldType[1].checked = false
        this.resetActiv()
	}
}

export default NumberOfGuest



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/async_filters/src/filters/NumberOfGuest.js